import { Client } from '@/utilities/api/Client';
import { QueryUtil } from '@/utilities/Query';
import { UserSyncEndpoint } from '@api/endpoints/UserSyncEndpoint';

export class UserSyncApi {
  static align (body: UserSyncEndpoint.Align.Request): Promise<UserSyncEndpoint.Align.Response> {
    return Client('admin/user-sync/align', { body, method: 'POST' });
  }

  static getAlignProgress (): Promise<UserSyncEndpoint.Align.AlignProgress> {
    return Client('admin/user-sync/align');
  }

  static createSignIn (
    body: UserSyncEndpoint.CreateSignIn.Request,
  ): Promise<UserSyncEndpoint.ActionResponse> {
    return Client('admin/user-sync/sign-in', { body, method: 'POST' });
  }

  static deleteAccount (
    body: UserSyncEndpoint.DeleteAccount.Request,
  ): Promise<UserSyncEndpoint.ActionResponse> {
    return Client('admin/user-sync/delete-account', { body, method: 'POST' });
  }

  static link (body: UserSyncEndpoint.Link.Request): Promise<UserSyncEndpoint.ActionResponse> {
    return Client('admin/user-sync/link', { body, method: 'POST' });
  }

  static list (query: UserSyncEndpoint.List.Query): Promise<UserSyncEndpoint.List.Response> {
    return Client(`admin/user-sync?${QueryUtil.stringify(query)}`);
  }

  static removeLp (
    body: UserSyncEndpoint.RemoveLp.Request,
  ): Promise<UserSyncEndpoint.ActionResponse> {
    return Client('admin/user-sync/remove-lp', { body, method: 'POST' });
  }

  static keepPhone (
    body: UserSyncEndpoint.KeepPhone.Request,
  ): Promise<UserSyncEndpoint.ActionResponse> {
    return Client('admin/user-sync/phone', { body, method: 'POST' });
  }
}
